"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkPaginatedPropsError = exports.getSliceByRange = exports.getNearestValidRangeBottom = exports.getPage = exports.reorderColumn = exports.getSortedData = void 0;
/** @deprecated Will be removed in a future major release */
function getSortedData(data, orderBy, order) {
    if (!data)
        return [];
    if (orderBy) {
        return data.sort(function (a, b) {
            if (b[orderBy] === a[orderBy])
                return 0;
            // default to ascending
            var sortBool = order === 'desc' ? b[orderBy] < a[orderBy] : a[orderBy] < b[orderBy];
            return sortBool ? -1 : 1;
        });
    }
    return data;
}
exports.getSortedData = getSortedData;
/** @deprecated Will be removed in a future major release */
var reorderColumn = function (list, startIndex, endIndex) {
    var result = Array.from(list);
    var removed = result.splice(startIndex, 1)[0];
    result.splice(endIndex, 0, removed);
    return result;
};
exports.reorderColumn = reorderColumn;
/** @deprecated Will be removed in a future major release */
var getPage = function (rangeTop, rangeBottom) {
    var rowsPerPage = rangeTop - rangeBottom + 1;
    // pages and data are 0-indexed
    return (rangeBottom - 1) / rowsPerPage;
};
exports.getPage = getPage;
var getNearestValidRangeBottom = function (rangeBottom, newRowsPerPage) {
    var newRangeBottom = rangeBottom;
    if ((rangeBottom - 1) % rangeBottom !== 0) {
        newRangeBottom =
            Math.floor(rangeBottom / newRowsPerPage) * newRowsPerPage + 1;
    }
    return newRangeBottom;
};
exports.getNearestValidRangeBottom = getNearestValidRangeBottom;
/** @deprecated Will be removed in a future major release */
var getSliceByRange = function (data, bottom, top) {
    // Translate 1-index ranges to 0-index and include top of range
    // e.g. 16-30 should be index 15-30 not including 30
    return data.slice(bottom - 1, top);
};
exports.getSliceByRange = getSliceByRange;
/** @deprecated Will be removed in a future major release */
var checkPaginatedPropsError = function (props) {
    var missingProps = [];
    var requiredProps = ['rangeBottom', 'rangeTop', 'count', 'updatePage'];
    requiredProps.forEach(function (propName) {
        if (!props[propName])
            missingProps.push(propName);
    });
    return (missingProps.length > 0 &&
        "Missing props for paginated data: ".concat(missingProps.join(', ')));
};
exports.checkPaginatedPropsError = checkPaginatedPropsError;
//# sourceMappingURL=helpers.js.map